//Paquetes NPM de GYF.
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, LogsProxy } from 'com-gyf-webcore-servicehub';

//Exportación de constantes
export const GET_CONFIGURACION_CONTRASENA_START = 'GET_CONFIGURACION_CONTRASENA_START';
export const GET_CONFIGURACION_CONTRASENA_SUCCESS = 'GET_CONFIGURACION_CONTRASENA_SUCCESS';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const ACTUALIZAR_CONTRASENA = 'ACTUALIZAR_CONTRASENA';
export const ACTUALIZAR_CONTRASENA_SUCCESS = 'ACTUALIZAR_CONTRASENA_SUCCESS';
export const ACTUALIZAR_CONTRASENA_FAIL = 'ACTUALIZAR_CONTRASENA_FAIL';
export const RESET_CAMBIO_CONTRASENA = "RESET_CAMBIO_CONTRASENA";

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

/**
 * Action que realiza la autenticacion del usuario.
 * @param {any} user - El usuario a autenticar.
 * @param {any} password - El password ingresado por el usuario.
 */
export function getConfiguracionContrasena() {
    LogHelper.In(getConfiguracionContrasena.name);

    return (dispatch, getState) => {
        dispatch({ type: GET_CONFIGURACION_CONTRASENA_START });

        //const state = getState();
        LogHelper.Out(getConfiguracionContrasena.name, null, 'GET_CONFIGURATION_PASSWORD_SESION', 'Get', "Concierge", "Seguridad", 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_SESION', 'Get', "Concierge", "Seguridad", 1, 'Product');
        Engine1Proxy.Execute((data) => getConfiguracionContrasenaResult(data, dispatch));
    }
}

/**
 * Action que realiza la actualizacion de la contraseña.
 * @param {any} data - Datos de actualización de contraseña. 
 */
export function actualizarContrasena(data) {
    LogHelper.In(actualizarContrasena.name, data);

    return (dispatch, getState) => {

        const state = getState();
        dispatch({ type: ACTUALIZAR_CONTRASENA });

        Engine1Proxy.AddRuleRequests(data, 'UpdateChangingPassword', 'Concierge', 'SEGURIDAD');
        Engine1Proxy.Execute((data) => actualizarContrasenaResult(data, dispatch, state));

        LogHelper.Out(actualizarContrasena.name);
    }
}

/**
 * Reinicia ele stado de la pantalla de cambio de contraseña
 */
export function reiniciarStateCambioContrasena() {
    return (dispatch) => {
        dispatch({ type: RESET_CAMBIO_CONTRASENA });
    }
}

/* --------------------------------------------- FUNCIONES AUXILIARES --------------------------------------------- */

/**
 * Callback de la ejecucion de Login.
 * @param {any} data - Data del callBack.
 * @param {any} dispatch - Dispatch.
 */
function getConfiguracionContrasenaResult(data, dispatch) {
    LogHelper.In(getConfiguracionContrasenaResult.name, data, dispatch);

    let validaciones = JSON.parse(data.GET_CONFIGURATION_PASSWORD_SESION).Recordset0.Rows[0];

    dispatch({ type: GET_CONFIGURACION_CONTRASENA_SUCCESS, validaciones });
}

/**
 * Callback de la ejecucion de Login.
 * @param {any} data - Data del callBack.
 * @param {any} dispatch - Dispatch.
 */
function actualizarContrasenaResult(data, dispatch, state) {
    LogHelper.In(actualizarContrasenaResult.name, data, dispatch, state);

    let action = null;
    let tags = null;
    const response = JSON.parse(data.UpdateChangingPassword);

    if (!response.isError) {

        tags = "SEGURIDAD,MODIFICACION,CONTRASEÑA";
        action = "Cambio de Contraseña del Usuario " + response.userName;
        LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");

        dispatch({ type: ACTUALIZAR_CONTRASENA_SUCCESS });

        //Refresco la pantalla para que se carguen denuevo todas las variables globales de razor.
        window.location.reload();
    }
    else {
        dispatch({ type: ACTUALIZAR_CONTRASENA_FAIL, data: response.errorMessage });
    }

    LogHelper.Out(actualizarContrasenaResult.name, data, dispatch);
}


// WEBPACK FOOTER //
// ./Portico/App/Screens/CambioContrasena/actions/ChangePasswordActions.js